import {useTranslation} from "react-i18next";
import {Insight, InsightProps} from "../Insight/Insight";
import {ActionIcon, Flex} from "@mantine/core";
import {IconSearch} from "@tabler/icons-react";
import {useNavigate} from "react-router-dom";

export type AvailableLoadsInsightProps = Pick<InsightProps, 'value' | 'loading'> & {
  showSearch?: boolean
}

export const AvailableLoadsInsight = (props: AvailableLoadsInsightProps) => {
  const {
    value,
    showSearch = false,
    ...rest
  } = props

  const {t} = useTranslation()
  const navigate = useNavigate()

  return (
    <Insight
      {...rest}
      title={t<string>("common.insight.availableloads", "Avail. Loads")}
      icon={"chartHistogram"}
      value={value}>
      {showSearch &&
        <Flex justify="flex-end">
          <ActionIcon onClick={() => navigate("/insights/available-loads-by")}>
            <IconSearch size="1.125rem"/>
          </ActionIcon>
        </Flex>
      }
    </Insight>
  )
}
